(ns storrito.connect3.connect-via-proxy
  (:require [storrito.ui.button :as button]
            [storrito.util.country-code :as country-code]))

(defn country-selection
  [state]
  (list
    [:div.flex.flex-col.m-0.items-center.justify-center
     [:h1.font-bold.text-xl.mb-4.text-left
      "Pick a location:"]

     [:div.m-0.text-left.flex.flex-row
      [:div.block.flex-grow.flex-shrink.pt-4.basis-0
       [:label.text-gray-800.block.text-base.font-bold.mb-2
        "Country"]

       [:div
        [:div.w-full.cursor-pointer.block.max-w-full.bg-white.border-gray-400.rounded.text-gray-800.text-md.outline-none
         {:style {:max-width "400px"}
          :placeholder "Country"
          :required true}
         [:select.w-full
          {:class "mt-1 mb-2 block w-full rounded-md border-gray-300 py-3 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
           :name "country"
           :on {:change [[:store/assoc-in [:connect3 :country] :event/target.value]]}
           ;; :value (:country w)
           }

          [:optgroup
           (doall (map
                    (fn [[country-name code]]
                      [:option.font-semibold
                       {:key (str code "-common")
                        :value code
                        ;; set preselected country
                        :selected (= code (:country state))
                        }
                       country-name])
                    (sort country-code/common-country-name->code)))]

          [:optgroup
           (doall (map
                    (fn [[country-name code]]
                      [:option
                       {:key code
                        :value code
                        ;; set preselected country
                        :selected (= code (:country state))
                        }
                       country-name])
                    (sort country-code/country-name->code)))]]]]]]]))

(defn panel
  [state]
  [:div.m-0.flex.flex-col
   [:div.flex.items-center.m-10.gap-5
    [:div
     (country-selection state)]
    ]

   [:div.flex.justify-end
    (button/button-primary
      {:class "self-end"
       ;; :disabled (:started w)
       ;; :type "submit"
       :on {:click [[:connect3/send! (select-keys state
                                                  [:proxy
                                                   :country
                                                   :city
                                                   :latitude
                                                   :longitude])]]}}
      "Proceed")]])
